import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Collapse, Link } from '@chakra-ui/react';
import { handleRefHeightChange, renderSanitizedHtml, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function HotelRestaurantMenuDescription(_ref) {
  var menuDescription = _ref.menuDescription;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCollapsibleOpen = _useState4[0],
    setIsCollapsibleOpen = _useState4[1];
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var getTypographyProps = useSemanticTypography();
  var linkName = isCollapsibleOpen ? t('hoteldetails.readless') : t('hoteldetails.readmore');
  return _jsxs(_Fragment, {
    children: [_jsxs(Box, _objectSpread(_objectSpread({}, menuDescriptionBoxStyles), {}, {
      children: [_jsx(Collapse, {
        startingHeight: height ? Math.min(height, 95) : 95,
        in: isCollapsibleOpen,
        "data-testid": "menu-description-collapse",
        children: _jsx(Box, _objectSpread(_objectSpread({
          ref: node => handleRefHeightChange(node, setHeight),
          className: "formatLinks"
        }, getTypographyProps({}, menuDescriptionSemanticTypography)), {}, {
          children: renderSanitizedHtml(menuDescription)
        }))
      }), !isCollapsibleOpen && height >= 95 && _jsx(Box, _objectSpread({}, fadeOutBoxStyles))]
    })), height >= 95 && _jsx(Link, _objectSpread(_objectSpread({
      color: "btnSecondaryEnabled"
    }, getTypographyProps({}, menuDescriptionLinkSemanticTypography)), {}, {
      sx: {
        ':hover': {
          textDecoration: 'none'
        }
      },
      onClick: () => setIsCollapsibleOpen(!isCollapsibleOpen),
      children: linkName
    }))]
  });
}
var fadeOutBoxStyles = {
  position: 'absolute',
  bottom: 0,
  h: '3.125rem',
  w: 'full',
  background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, var(--chakra-colors-baseWhite) 90%)'
};
var menuDescriptionBoxStyles = {
  position: 'relative',
  color: 'baseBlack'
};
var menuDescriptionSemanticTypography = {
  textStyle: 'body-m-regular'
};
var menuDescriptionLinkSemanticTypography = {
  textStyle: 'link-m-regular'
};